// DESCRIPTION: Inline field validation error message component.
// DESCRIPTION: Renders an accessible error (icon + text) below form fields when
// DESCRIPTION: validation fails. Text is always present, so state is never conveyed
// DESCRIPTION: by color alone.

const FieldError = ( { error } ) => {
	if ( ! error ) {
		return null;
	}

	return (
		<p
			className="nemtly-field-error nb-flex nb-items-center nb-gap-1 nb-text-danger-700 nb-text-xs nb-mt-1 nb-m-0"
			role="alert"
		>
			<svg
				className="nb-w-3.5 nb-h-3.5 nb-shrink-0"
				fill="currentColor"
				viewBox="0 0 20 20"
				aria-hidden="true"
			>
				<path
					fillRule="evenodd"
					d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
					clipRule="evenodd"
				/>
			</svg>
			{ error }
		</p>
	);
};

export default FieldError;
